import type { HttpDto } from "~/http/http.models"

export class FeatureFlagDto implements HttpDto<Record<string, boolean>> {
  declare readonly data: Record<string, boolean>
}
